// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-Bm9woJ{flex:1;align-items:center;width:100%;margin-bottom:8px;display:flex}.wrapper-Bm9woJ .icon-sending-WrCsGR{color:#4d53e8}.wrapper-Bm9woJ .icon-fail-YReqdw{cursor:pointer;color:#ff441e}.wrapper-Bm9woJ .icon-fail-YReqdw>svg{width:16px;height:16px}.wrapper-Bm9woJ .icon-fail-readonly-vq92Id{cursor:not-allowed}.wrapper--short-spacing-RKcIU8{margin-bottom:4px}.message-right-sVe3Cp{width:16px;height:16px;position:relative}.message-right-pc-JPEKK0{left:24px}.message-right-mobile-MZktsC{left:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-Bm9woJ`,
	"icon-sending": `icon-sending-WrCsGR`,
	"iconSending": `icon-sending-WrCsGR`,
	"icon-fail": `icon-fail-YReqdw`,
	"iconFail": `icon-fail-YReqdw`,
	"icon-fail-readonly": `icon-fail-readonly-vq92Id`,
	"iconFailReadonly": `icon-fail-readonly-vq92Id`,
	"wrapper--short-spacing": `wrapper--short-spacing-RKcIU8`,
	"wrapperShortSpacing": `wrapper--short-spacing-RKcIU8`,
	"message-right": `message-right-sVe3Cp`,
	"messageRight": `message-right-sVe3Cp`,
	"message-right-pc": `message-right-pc-JPEKK0`,
	"messageRightPc": `message-right-pc-JPEKK0`,
	"message-right-mobile": `message-right-mobile-MZktsC`,
	"messageRightMobile": `message-right-mobile-MZktsC`
};
export default ___CSS_LOADER_EXPORT___;
